import { Inject, Injectable } from '@angular/core';
import { DatePipe } from '@angular/common'
import { BaseEndpoint } from '../app.constants';
import { Headers, Http } from '@angular/http';
import { AdalService } from '../shared/azure-authentication/adal.service';

@Injectable()
export class LoanAssignmentService
{

    constructor(private http: Http, @Inject(BaseEndpoint) private baseApiUrl: string, private adalService: AdalService) { }

    async getRecentLogs() {
        const datepipe: DatePipe = new DatePipe('en-US')
        const url = this.baseApiUrl + 'v1/loanAssignment/' + datepipe.transform(new Date(), 'MM-dd-yyyy');
        let header = await this.adalService.createServiceHeader();
        return this.http.get(url, { headers: header }).toPromise().then(resp => {
            return resp.json().body;
        }).catch(this.handleError);
    }

    private handleError(errors: string[]): Promise<any> {
        console.error('An error occurred', errors);
        return Promise.reject(errors);
    }
}






// WEBPACK FOOTER //
// D:/a/1/s/Uhm.Loops.Web/src/app/loan-assignment/loanassignment.service.ts